// AI Generated: Text Testimonials component matching Figma design (node-id=1414-12257)
import React from 'react';
import styles from '$styles/ind/home/testimonials.module.scss';

interface ITestimonialsProps {
  isMobile?: boolean;
  isDesktop?: boolean;
}

interface ITestimonial {
  id: number;
  name: string;
  role: string;
  quote: string;
  image: string;
}

const testimonials: ITestimonial[] = [
  {
    id: 1,
    name: 'Rajesh Bafna',
    role: 'CA-turned-entrepreneur from Dada Brothers',
    quote: '"For bus fleet owners like us, this change opened doors we couldn\'t imagine earlier. Once permits and sleeper codes became streamlined, we could invest confidently in better coaches and explore intercity routes beyond Chhattisgarh."',
    image: '/public/images/testimonials/rajesh-bafna.png',
  },
  {
    id: 2,
    name: 'Jasjeet Singh Rehal',
    role: 'Founder of King Luxuries',
    quote: '"The market\'s momentum is undeniable. We started operations just this February and achieved a 4.9 rating within months. Demand for reliable, comfortable intercity travel is rising fast, and passengers are willing to pay for quality."',
    image: '/public/images/testimonials/jasjeet-singh.png',
  },
  {
    id: 3,
    name: 'Mr. Pradeesh Karthi',
    role: 'Delta Transport Pvt Ltd (Tamil Nadu)',
    quote: '"We proudly operated the longest routes for Kumbh, connecting Coimbatore and BLR to Prayagraj. These routes saw an overwhelming demand and occupancy, with redBus playing a crucial role in driving bookings and making it a highly successful season."',
    image: '/public/images/testimonials/pradeesh-karthi.png',
  },
];

const Testimonials: React.FC<ITestimonialsProps> = () => {
  return (
    <section className={styles.testimonials} id="testimonials">
      <div className={styles.container}>
        <h2 className={styles.sectionTitle}>
          See what our operators are saying about us
        </h2>

        <div className={styles.testimonialCards}>
          {testimonials.map((testimonial) => (
            <div key={testimonial.id} className={styles.testimonialCard}>
              {/* Quote */}
              <p className={styles.quote}>{testimonial.quote}</p>

              {/* Divider */}
              <div className={styles.divider} />

              {/* Author Info */}
              <div className={styles.authorInfo}>
                <img
                  src={testimonial.image}
                  alt={testimonial.name}
                  className={styles.authorImage}
                  loading="lazy"
                />
                <div className={styles.authorDetails}>
                  <h3 className={styles.authorName}>{testimonial.name}</h3>
                  <p className={styles.authorRole}>{testimonial.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
// AI Generated: End of text testimonials component
